import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * Steps the admin operator can choose to run via the migration card.
 * Mirrors `MigrateTeamToSupportV2Step` in
 * `redo/temporal/definitions/src/cxp-namespace/workflows/migrate-team-to-support-v2.ts`
 * — keep the two lists in sync.
 */
export const MigrateTeamToSupportV2Step = z.enum([
  "INTEGRATIONS",
  "TAGS",
  "CONVERSATIONS",
  "SETTINGS_BACKFILL",
  "RULES_V2_TO_V3",
]);
export type MigrateTeamToSupportV2Step = z.infer<
  typeof MigrateTeamToSupportV2Step
>;

export const migrateTeamToSupportV2 = {
  name: "migrateTeamToSupportV2" as const,
  input: z.object({
    teamId: zExt.objectId(),
    /**
     * Optional subset. When omitted or empty, every step runs.
     */
    steps: z.array(MigrateTeamToSupportV2Step).optional(),
  }),
  output: z.object({ workflowId: z.string() }),
};
